import {
  ActivityEvent,
  ActivityEventActivities,
  ActivityEventsByCreatorQuery,
  CreateActivityEventActivitiesInput,
  CreateActivityEventActivitiesMutation,
  CreateActivityEventActivitiesMutationVariables,
  CreateActivityEventInput,
  CreateActivityEventMutation,
  CreateActivityEventMutationVariables,
  ListActivityEventsQuery,
  ModelActivityEventConnection
} from "../../API";
import * as queries from "../../graphql/queries";
import * as mutations from "../../graphql/mutations";
import { genericQuery, listQueryAutoPaginated } from "../api/apiUtils";

export const fetchAllActivityEvents = async (predicate?: object) => {
  return await listQueryAutoPaginated<
    ListActivityEventsQuery,
    ActivityEvent,
    ModelActivityEventConnection
  >(queries.listActivityEvents, "listActivityEvents", "items", predicate);
};

export const fetchActivityEventsByCreatorId = async (creatorId: string) => {
  const predicate = { creatorId: creatorId };
  return await listQueryAutoPaginated<
    ActivityEventsByCreatorQuery,
    ActivityEvent,
    ModelActivityEventConnection
  >(
    queries.activityEventsByCreator,
    "activityEventsByCreator",
    "items",
    predicate
  );
};

export const createActivityEvent = async (
  creatorId: string,
  programId: string,
  activityEventDate: string
) => {
  const predicate: CreateActivityEventInput = {
    creatorId: creatorId,
    programId: programId,
    activityEventDate: activityEventDate
  };
  const input: CreateActivityEventMutationVariables = { input: predicate };
  return await genericQuery<CreateActivityEventMutation, ActivityEvent>(
    mutations.createActivityEvent,
    "createActivityEvent",
    input
  );
};

export const createActivityEventActivities = async (
  activityId: string,
  activityEventId: string
) => {
  const predicate: CreateActivityEventActivitiesInput = {
    activityID: activityId,
    activityEventID: activityEventId
  };
  const input: CreateActivityEventActivitiesMutationVariables = {
    input: predicate
  };
  return await genericQuery<
    CreateActivityEventActivitiesMutation,
    ActivityEventActivities
  >(
    mutations.createActivityEventActivities,
    "createActivityEventActivities",
    input
  );
};
